import {ActivatedRoute, Router} from '@angular/router';
import {Step} from '../application-flow/steps/step';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {IntroStep} from '../application-flow/steps/intro.step';
import {Keys, StorageService} from '../service/storage.service';
import {ReferralInputComponent} from '../referral-input/referral-input.component';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {AbstractApplicationFlowComponent} from '../application-flow/abstract-application-flow.component';
import {VerificationState} from '../model/verification-state.model';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';

@Component({
    selector: 'app-intro',
    styleUrls: ['./intro.component.css'],
    templateUrl: './intro.component.html',
})
export class IntroComponent extends AbstractApplicationFlowComponent implements OnInit {
    @ViewChild(ReferralInputComponent)
    referralInput: ReferralInputComponent;

    loaderStatus = new LoaderStatus();
    isUserRegistered: boolean;
    public referralFeatureEnabled: boolean;
    public readonly analyticsTracker: AnalyticsTracker;
    private readonly router: Router;
    private readonly route: ActivatedRoute;

    constructor(router: Router, private storageService: StorageService, analyticsTracker: AnalyticsTracker,
                navigator: LoanApplicationFlowNavigator, route: ActivatedRoute) {
        super(navigator);
        this.router = router;
        this.analyticsTracker = analyticsTracker;
        this.route = route;
        this.referralFeatureEnabled = ApiServiceService.isReferralSchemeEnabled();
    }

    async ngOnInit() {
        this.isUserRegistered = !!this.storageService.getItem(Keys.PROFILE_ID);
    }

    async verifyAndProceed(): Promise<void> {
        await executeWithLoader(this.loaderStatus, async () => {
            if (!this.referralFeatureEnabled) {
                await this.nextPage();
            } else {
                const verificationState = await this.referralInput.verifyReferralCode();
                if (verificationState === VerificationState.VERIFIED || verificationState === VerificationState.NA) {
                    await this.nextPage();
                }
            }
        });
    }

    step(): new(...args: any[]) => Step {
        return IntroStep;
    }

    protected errorMessages(): object {
        return {};
    }
}
